module.exports = __webpack_public_path__ + "img/razzo2.4fe8e863.webp";